import { TypeInitProps, TypeRequest } from '../../types';
import { APP_URL, MOBILE_AFF_URL } from '../../utils/urls';
export default class LoginAPI {
  private request: TypeRequest;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }

  /**
   * @param {string} code - user code returned by open service
   * @param {string} profile_key - user code returned by other process
   * @param {number} platform_app_id - apply for configuration in appcloud
   * @param {string} platform - third-party name
   * @param {number} need_mobile - whether synchronize the mobile of third-party account
   * @param {number} check_mobile - whether restrict old user to bind mobile forcely
   * @param {number} change_bind - whether rebind forcely when conflict occurs
   * @return {Promise} login result
   */
  bindWithMobileLogin = (params: {
    code?: string;
    profile_key?: string;
    platform_app_id: number;
    platform: string;
    need_mobile?: number;
    check_mobile?: number;
    change_bind?: number;
    extra_params?: object;
  }) => {
    const { extra_params = {}, ...props } = params;
    return this.request({
      url: APP_URL.BIND_WITH_MOBILE_LOGIN,
      method: 'POST',
      data: { ...extra_params, ...props },
    });
  };

  /**
   * @param {number} platform_app_id - the app id of the third party used to login
   * @param {string} platform - third-party name
   * @param {string} code - authorization code
   * @param {string} access_token - third-party authorization token
   * @param {string} access_token_secret - id token, only neccessary when using google to login
   * @param {string} openid - third-party openid, used with access_token
   * @param {string} profile_key - third-party ticket that preserves information temporaily, used when the login progress is blocked
   * @param {boolean} login_only - whether to login only, not allowing to register
   * @return {Promise} login result
   */
  authLogin = (params: {
    platform_app_id: number;
    platform: string;
    code?: string;
    access_token?: string;
    access_token_secret?: string;
    openid?: string;
    profile_key?: string;
    extra_params?: object;
  }) => {
    const { extra_params = {}, ...props } = params;
    return this.request({
      url: APP_URL.AUTH_LOGIN,
      method: 'POST',
      data: { ...extra_params, ...props },
    });
  };

  /**
   * [Industry account user switching mobile]
   * @param {string} Industry account system userIdentityId
   */
  memberSwitch = (params: { to_sec_member_id: string }) => {
    let { to_sec_member_id } = params;
    return this.request({
      url: MOBILE_AFF_URL.MEMBER_SWITCH,
      method: 'POST',
      data: {
        to_sec_member_id,
      },
    });
  };
}
